<template>
  <OldShop />
</template>
<script>
import OldShop from "@/components/OldShop.vue";
export default {
  components: {
    OldShop
  }
}
</script>